import Api from '@/api/Api'
import store from '../store'

export default {

  async getSingle (data) {
    var params = ''

    if (data.product_id) {
      params = '?product_id=' + data.product_id
    } else if (data.sku_id) {
      params = '?sku_id=' + data.sku_id
    }

    return store.dispatch('checkResponseApi', await Api().get('product' + params))
  },

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('products', { params }))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('product', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('product', data, options))
  },

  async updateByImport (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('product/by-import', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('product', { data: data }, options))
  },

  async getUnits () {
    return store.dispatch('checkResponseApi', await Api().get('product/units'))
  },

  async getNames () {
    return store.dispatch('checkResponseApi', await Api().get('product/names'))
  },

  async getBarcodes () {
    return store.dispatch('checkResponseApi', await Api().get('product/barcodes'))
  },

  async getPosProducts (params) {
    return store.dispatch('checkResponseApi', await Api().get('products/pos', { params }))
  },

  async getSkuLatestCode () {
    return store.dispatch('checkResponseApi', await Api().get('product/sku/latest_code'))
  },

  async getSkuAllCode () {
    return store.dispatch('checkResponseApi', await Api().get('product/sku/all_code'))
  },

  async getSkuAllAttributes () {
    return store.dispatch('checkResponseApi', await Api().get('product/sku/all_attributes'))
  },

  async assignLotSerial (data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put('product/sku/inventory/assign-lot-serial', data, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/ProductService.js